import { useEffect, useState } from "react";
import { Scrollbars } from "@tecorien/mimic-v2";
import classNames from "classnames";
import ReactResizeDetector, { useResizeDetector } from "react-resize-detector";
import { Filters, HeaderGroup, Row } from "react-table";
import { genericMemo } from "../../../../../utils";
import { Body } from "./Body/Body";
import { BodyRowProps } from "./Body/BodyRow";
import FilterContext from "./contexts/FilterContext";
import SelectionContext from "./contexts/SelectionContext";
import TableWidthContext from "./contexts/TableWidthContext";
import Footers from "./Footer/Footers";
import Headers from "./Header/Headers";

import styles from "./style.module.scss";

interface TableProps<T extends object> {
  page: Row<T>[],
  selectedFlatRows: Row<T>[],
  prepareRow: (row: Row<T>) => void,
  allowRowSelect?: boolean,
  headerGroups: HeaderGroup<T>[],
  footerGroups: HeaderGroup<T>[],
  showFooter?: boolean,
  loading?: boolean,
  filters: Filters<object>,
  getRowProps?: (row: Row<T>) => Partial<BodyRowProps<T>> | undefined,
  pageSize: number,
  className?: string,
}

export const Table = genericMemo(<T extends object>(
  {
    page,
    selectedFlatRows,
    prepareRow,
    allowRowSelect,
    headerGroups,
    footerGroups,
    showFooter,
    loading,
    filters,
    getRowProps,
    pageSize,
    className,
    ...restProps
  }: TableProps<T>,
) => {
  const [ hasData, setHasData ] = useState(false);
  const isLoading = loading || false;

  useEffect(() => {
    if (page?.length) {
      setHasData(true);
    } else if (page?.length === 0) {
      setHasData(false);
    }
  }, [ page?.length ]);

  const { ref, width } = useResizeDetector({ handleWidth: true });//Attempt №1.0 to fix an issue with findDOMNode in frontend

  return (
    // <ReactResizeDetector handleWidth>
    //   {({ width }) =>
    <TableWidthContext.Provider value={width ?? 0}>
      <div ref={ref as any} {...restProps} className={classNames(styles.root, className)}>
        <Scrollbars
          role="scrollbar"
        >
          <SelectionContext.Provider value={selectedFlatRows}>
            <FilterContext.Provider value={filters}>
              <Headers
                headerGroups={headerGroups}
              />
              <Body
                loading={isLoading}
                hasData={hasData}
                pageSize={pageSize}
                page={page}
                prepareRow={prepareRow}
                getRowProps={getRowProps}
                showFooter={showFooter}
              />
              {
                (showFooter && !isLoading && hasData) && <Footers footerGroups={footerGroups} />
              }
            </FilterContext.Provider>
          </SelectionContext.Provider>
        </Scrollbars>
      </div>
    </TableWidthContext.Provider>
    //   }
    // </ReactResizeDetector>
  );
});

export default Table;


